import { ICmmsAssignee } from './assignee.interface';
import { ICMMSLocation } from './cmms-global.interfaces';

export interface IDetectionTask {
	id: string;
	fileId: string;
	locationId: string;
	locations?: ICMMSLocation[];
	performedAt?: string;
	performedBy: string;
	results: string;
	updatedAt?: string;
}
export enum DetectionTaskStatus {
	CREATED,
	RETRIEVED,
	ERROR,
}

export interface ICreateDetectionTaskVariables {
	fileId: string;
	locationId?: string;
	performedBy: string;
	url: string;
}

export interface IDetectionResult {
	createDetectionTask?: {
		detectionTask: IDetectionTask;
	};
}

export interface IGetDetectionResult {
	detectionTask: IDetectionTask;
}

export interface ICreateDetectedIncidentStructure {
	incidentTaskData: IResultData;
	location: ICMMSLocation[];
}

export type IncidentDetectedStatus = 'CREATED' | 'DELETED' | 'DISCARDED' | 'NOSTATUS';
export interface IResultData {
	ID: string;
	category: string;
	description: string;
	due_date: string;
	name: string;
	priority: string | number; //Its int on stage, but on qa its sometimes string sometimes int.
	approvedBy?: ICmmsAssignee;
	assignee?: ICmmsAssignee;
	status: IncidentDetectedStatus | undefined;
	incident?: { id: string; pk: string };
}
export interface IIncidentDetection {
	fileId: string;
}
export interface IUpdateDetectionTaskVariables {
	fileId: string;
	resultId: string;
	result: IResultData[];
	updateValues: { [key: string]: any };
}
